var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ais-search-box',[_c('ais-input',{staticClass:"border input-group pa-2 fs-14",attrs:{"placeholder":"Search product"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }